import { observer } from 'mobx-react-lite'
import React from 'react'

import { Playlist } from '@/components/Playlist'

export const PreviousSongs = observer(function PreviousSongs(): React.ReactElement {
  return (
    <>
      <h2>Last 3 Played</h2>

      <Playlist
        enableDimmedPlayedSongs={false}
        enableRowAudioFeatures={false}
        scrollContainer='element'
        scrollToSong='next'
        showFullPlaylist={false}
      />
    </>
  )
})
